import React from "react";

export default function GlobalErrorMessage({ children }) {
  return <div className="global-error-message">{children}</div>;
}

// export default function GlobalErrorMessage({ children }) {
//   return <div className="alert alert-danger alert-icon-danger">{children}</div>;
// }
